import utils from './modules/utils';
import {startOrderProcessing} from './v2/actions/site-actions';
import * as pollers from './v2/api/pollers/pollers';
import page from './v2/page/page';
import {isOrderProcessing} from './v2/selectors/selectors';
import store from './v2/store/store';

function init() {
  window.onerror = (msg, url, linenumber, columnNo, error) => {
    console.log(JSON.stringify(error));
  };
  
  //* ****NEW DELIVERY OPTION RETURN FROM HOST PAYMENTS*****//
  let reactProcessHostPayment = false;
  
  function processReturnFromAdyen() {
    const url = '/checkout-api/v2/return-from-hosted/adyen';
    pollers.adyenStatusPoller.execPost(window.location.search.substring(1), 'POST', url);
  }
  
  function resolvePaymentProcessReturnFromAdyen() {
    const url = '/checkout-api/v2/return-from-hosted/adyen';
    pollers.resolvePaymentAdyenStatusPoller.execPost(window.location.search.substring(1), 'POST', url);
  }
  
  store.subscribe(() => {
    const state = store.getState();
    const orderIsBeingProcessed = isOrderProcessing(state);
    if (state.site.returnFromHostPayment && !reactProcessHostPayment) {
      if (utils.fn.getURIParam(window.location.search, 'trade_status')
        && orderIsBeingProcessed) {
        reactProcessHostPayment = true;
      }
      
      if (utils.fn.getURIParam(window.location.search, 'paymentMethod')
        && orderIsBeingProcessed) {
        reactProcessHostPayment = true;
        processReturnFromAdyen();
      }
      
      if (utils.fn.getURIParam(window.location.search, 'PayerID') && orderIsBeingProcessed) {
        reactProcessHostPayment = true;
        pollers.paypalStatusPoller.execPost();
      }
      
      if (utils.fn.getURIParam(window.location.search, 'klarna') && orderIsBeingProcessed) {
        reactProcessHostPayment = true;
        pollers.klarnaReturnStatusPoller.execPost();
      }
      
      if (utils.fn.getURIParam(window.location.search, 'orderToken')
        && utils.fn.getURIParam(window.location.search, 'status') === 'SUCCESS'
        && orderIsBeingProcessed) {
        reactProcessHostPayment = true;
        pollers.afterPayStatusPoller.execPost();
      }
  
      if (utils.fn.getURIParam(window.location.search, 'tno')
        && utils.fn.getURIParam(window.location.search, 'status') === 'SUCCESS'
        && orderIsBeingProcessed) {
        reactProcessHostPayment = true;
        pollers.kcpStatusPoller.execPost();
      }
    }
  });
  
  //* ****NEW DELIVERY OPTION RETURN FROM HOST PAYMENTS*****//
  
  // TODO - we should change our return urls to contain the
  // correct payment method name rather than using this brittle convention
  // --- Returned from PayPal ---
  if (utils.fn.getURIParam(window.location.search, 'PayerID')) {
    store.dispatch(startOrderProcessing());
  }
  
  if (utils.fn.getURIParam(window.location.search, 'klarna')) {
    store.dispatch(startOrderProcessing());
  }
  
  if (utils.fn.getURIParam(window.location.search, 'orderToken') && utils.fn.getURIParam(window.location.search, 'status') === 'SUCCESS') {
    store.dispatch(startOrderProcessing());
  }
  
  // --- Returned from Adyen ---
  if (utils.fn.getURIParam(window.location.search, 'paymentMethod') && page.isOnPage('checkout')) {
    store.dispatch(startOrderProcessing());
  }
  
  if (utils.fn.getURIParam(window.location.search, 'paymentMethod') && page.isOnPage('payment-resolution')) {
    store.dispatch(startOrderProcessing());
    resolvePaymentProcessReturnFromAdyen();
  }
}

export default {init};
